import { styled } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useId } from 'react';
import type { ComponentProps } from 'react';

import { ChkIconProhibit } from '@ui/checkout-components';

type ErrorBase64ImageProps = ComponentProps<typeof Wrapper> & {
  a11yDescription: string;
};

export const ErrorBase64Image = ({
  children,
  a11yDescription,
  ...props
}: ErrorBase64ImageProps) => {
  const labelId = useId();

  return (
    <>
      <Wrapper
        role="img"
        aria-labelledby={labelId}
        data-testid="base64-image-fallback"
        {...props}
      >
        <Icon aria-hidden="true" />
        {children}
      </Wrapper>
      <p id={labelId} style={visuallyHidden}>
        {a11yDescription}
      </p>
    </>
  );
};

const Wrapper = styled('div')(({ theme }) => ({
  alignItems: 'center',
  aspectRatio: '1/1',
  backgroundColor: theme.coreTokens.background.soft,
  borderRadius: theme.shape.borderRadius,
  color: theme.coreTokens.text.muted,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

const Icon = styled(ChkIconProhibit)({
  width: '33%',
  height: '33%',
});
